import PersonBody from './PersonBody';

const PersonView = (props) => {
  const { data, properties } = props;
  return (
    <PersonBody
      content={properties}
      layout={data?.layout}
      summary={data?.summary}
      showDescription={data?.showDescription}
      hideName={data?.hideName}
      showPersonLink={data?.showPersonLink}
    />
  );
};

export default PersonView;
